import React from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AccountInquiryDetails = ({ rowData}) => {

    return (
        <>
            <Box className="userInformationcontainer">
                <Accordion component="div" defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        component="div"
                    >
                        <Typography component="h2" className='userInformation'>Profile Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Grid container spacing={3}>
                            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>

                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">Account Number</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.AccountNumber}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>

                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">Account Holder</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.AccountHolder}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>

                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">secondary name</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.SecondaryName}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>
                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">Phone Number</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.PhoneNumber}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">Service Address</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.ServiceAddress}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>

                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">billing Address</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright">{rowData.BillingAddress}</Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>
                                <Typography component="div" className="UserName">
                                    <Grid container spacing={3}>
                                        <Grid size={{ xs: 6, sm: 6, md: 4 }}>
                                            <Typography component="span" className="textleft">Account Balance</Typography>
                                        </Grid>
                                        <Grid size={{ xs: 6, sm: 6, md: 8 }}>
                                            <Typography component="span" className="textright"><span className='textrighttext'>{`$ ${rowData.AmountDue}`}</span></Typography>
                                        </Grid>
                                    </Grid>
                                </Typography>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>
    );
};

export default AccountInquiryDetails;